import { createReducer } from '@reduxjs/toolkit';
import { actions } from './actions';
const initialState = {
    data: {
        _path: '',
        partnerName: '',
        partnerPhone: '',
        partnerEmail: '',
        partnerAddress: '',
        partnerIntro: {
            html: '',
        },
        partnerLogo: {
            src: '',
        },
        partnerWebsiteUrl: '',
        priority: 0,
    },
};
function setPartnerDetailsData(state, { payload }) {
    return {
        ...state,
        data: payload,
    };
}
export const reducer = createReducer(initialState, (builder) => {
    builder
        .addCase(actions.setPartnerDetailsData, setPartnerDetailsData)
        .addCase(actions.setInitialPartnerDetailsData, () => initialState);
});
